export default params => {
  const evt = new KeyboardEvent('keydown', params);
  // https://stackoverflow.com/a/11939345
  // for WebOS mouse click events
  delete evt.keyCode;
  Object.defineProperty(evt, 'keyCode', { value: params.keyCode });
  document.body.dispatchEvent(evt);
};
